
<template>
  <div id="medal-son">
    <div v-if="showSinglePerMedalDetailsFlag&&medal[medalOrder]" id="single-per-medal-details" class="medal-details" :style="{height:`${medalDetailsHeight}px`,top:`${medalDetailTop}px`}">
      <div  v-for="(detailItem, singleindex) in medal[medalOrder]" :key="singleindex+'perDetail'" class="per-medal-details">
        <div class="medal-player-name">
          {{ detailItem.player_name }}
        </div>
        <div class="player-medal-number">{{ detailItem.medal_number }}</div>
      </div>
    </div>
    <div v-if="showTeamMedalDetailsFlag&&teamMedal[teamMedalOrder]" id="team-medal-details" class="medal-details" :style="{height:`${teamMedalDetailsHeight}px`,top:`${teamMedalDetailTop}px`}">
      <div  v-for="(detailItem, singleindex) in teamMedal[teamMedalOrder]" :key="singleindex+'perDetail'" class="per-medal-details">
        <div class="medal-event-name">
          {{ detailItem.match_name }}
        </div>
<!--        <div class="player-medal-number">{{ 1 }}</div>-->
      </div>
    </div>

    <div v-if="showTwoPerMedalDetailsFlag&&medal[medalOrder]" id="two-per-medal-details" class="medal-details" :style="{height:`${medalDetailsHeight}px`,top:`${medalDetailTop}px`}" >
      <div  v-for="(detailItem, singleindex) in medal[medalOrder]" :key="singleindex+'perDetail'" class="per-medal-details">
        <div class="medal-event-name">{{ detailItem.player1_name }}&nbsp;&nbsp;{{ detailItem.player2_name }} </div>
        <div class="player-medal-number">
          {{ detailItem.medal_number }}
        </div>
        <br>
      </div>
    </div>

  <div id="medal-div">
       <div class="first-medal medal-item" @mouseover="showMedalDetails(0)" @mouseleave="removeMedalDetails(0)">

         <img src="@/assets/gold.png"  class="medal-img"  style="background-color: white" />
         冠军数
         <div v-if="medal[3]" class="per-medal-total">{{ medal[3][0] }}</div>
       </div>
       <div class="second-medal medal-item"
            @mouseover="showMedalDetails(1)"
            @mouseleave="removeMedalDetails(1)">
         <img src="@/assets/silver.png" class="medal-img"  style="background-color: white" />
         亚军数
         <div v-if="medal[3]" class="per-medal-total">{{ medal[3][1] }}</div>
       </div>
       <div class="third-medal medal-item"
            @mouseover="showMedalDetails(2)"
            @mouseleave="removeMedalDetails(2)" >
         <img src="@/assets/bronze.png" class="medal-img"  style="background-color: white" />
        季军数
         <div v-if="medal[3]" class="per-medal-total">{{ medal[3][2] }}</div>
       </div>
  </div>
    <div id="medal-div-team">
    <div class="first-medal medal-item" @mouseover="showTeamMedalDetails(0)" @mouseleave="removeTeamMedalDetails(0)">

      <img src="@/assets/gold.png"  class="medal-img"  style="background-color: white" />
      团体冠军数
      <div v-if="teamMedal && teamMedal.length" class="per-medal-total">{{ teamMedal && teamMedal[0].length}}</div>
    </div>
    <div class="second-medal medal-item"
         @mouseover="showTeamMedalDetails(1)"
         @mouseleave="removeTeamMedalDetails(1)">
      <img src="@/assets/silver.png" class="medal-img"  style="background-color: white" />
      团体亚军数
      <div v-if="teamMedal && teamMedal.length" class="per-medal-total">{{ teamMedal && teamMedal[1].length }}</div>
    </div>
    <div class="third-medal medal-item"
         @mouseover="showTeamMedalDetails(2)"
         @mouseleave="removeTeamMedalDetails(2)" >
      <img src="@/assets/bronze.png" class="medal-img"  style="background-color: white" />
      团体季军数
      <div v-if="teamMedal && teamMedal.length" class="per-medal-total">{{ teamMedal && teamMedal[2].length}}</div>
    </div>
    </div>
  </div>

</template>

<script>
export default {
  data(){
    return {
      showSinglePerMedalDetailsFlag:false,
      showTwoPerMedalDetailsFlag:false,
      showTeamMedalDetailsFlag: false,
      medal: [],
      medalOrder:0,
      medalDetailTop:0,
      teamMedal:[],
      teamMedalOrder:0,
      teamMedalDetailTop:0,
    }
  },
  props:{
    "medalList":{
      type:Array,
      default:()=>null
    },
    "teamMedalList":{
      type:Array,
      default:()=>null
    },
    "type":{
      type:String,
      default:'single'
    }
  },
  computed:{
    medalDetailsHeight(){
      const medalArray = this.medal[this.medalOrder];
      return medalArray ? medalArray.length * 29 : 0;
    },
    teamMedalDetailsHeight(){
      const medalArray = this.teamMedal[this.teamMedalOrder];
      return medalArray ? medalArray.length * 29 * 2 : 0;
    },

  },
  watch:{
    medalList:{
      handler(value){
        if(value){
          this.medal = value;
          // console.log('value',this.medal);
        }
      },
      immediate: true,
      deep: true,
    },
    teamMedalList:{
      handler(value){
        if(value){
          this.teamMedal = value;
          // console.log('value',this.medal);
        }
      },
      immediate: true,
      deep: true,
    },

  },
  mounted() {
    this.init();
    // console.log("llll",this.medalList);
    // console.log("kkkk",this.medal);
    // console.log(this.showSinglePerMedalDetailsFlag)
  },
  methods:{
    init(){
      // console.log("mmmmm",this.medal);
    },

    showMedalDetails(index) {
     this.medalOrder=index;
     if(this.medal[this.medalOrder] && this.medal[this.medalOrder].length!==0){
       if(this.type==='single'){
         this.showSinglePerMedalDetailsFlag = true;
         // console.log(this.showSinglePerMedalDetailsFlag);
       }
       else if(this.type === 'double' || this.type === 'mixed'){
         this.showTwoPerMedalDetailsFlag = true;
       }
       this.medalDetailTop=28*index;
     }

   },
    showTeamMedalDetails(index) {
      this.teamMedalOrder=index;
      if(this.teamMedalList[this.teamMedalOrder] && this.teamMedalList[this.teamMedalOrder].length!==0){

        this.showTeamMedalDetailsFlag = true;

        this.teamMedalDetailTop=28*(index+3);
      }

    },
   removeMedalDetails(index) {
      // console.log(index)
     this.medalOrder=index;
     if(this.type==='single'){
       this.showSinglePerMedalDetailsFlag = false;
       // console.log(this.showSinglePerMedalDetailsFlag);
     }
     else if(this.type === 'double' || this.type === 'mixed'){
       this.showTwoPerMedalDetailsFlag = false;
     }
   },
    removeTeamMedalDetails(index) {
      this.teamMedalOrder=index;
        this.showTeamMedalDetailsFlag = false;

    },
  }
}
</script>

<style >
#medal-son{
  width: 300px;
  height: 250px;
  display: flex;
}
#medal-div {
  position:absolute;
  right:0;
  width: 158px;
  height: 100px;
  font-size: 16px;
  top:0;
  background: white;

}
#medal-div-team {
  position:absolute;
  right:0;
  width: 158px;
  height: 100px;
  font-size: 16px;
  top:100px;
  background: white;

}

.medal-item{
  display: flex;
  align-items: center;
  cursor: pointer;
}
.medal-img {
  width:28px ;
  height: 28px;
}
.medal-details{
  position:absolute;
  left:0;
  border: 1px solid black;
  font-size: 16px;
  border-radius: 6px;
  background: white;
}
.per-medal-details{
  margin-top:3px;
  display: flex;
  margin-bottom: 3px;
}
.per-medal-details-team{
  margin-top:3px;
  display: flex;
  margin-bottom: 3px;
  margin-left: 10px;
}
.per-medal-total{
  width:20px ;
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
}

#single-per-medal-details{
  width: 145px;
  margin-left: -20px;
}
#team-medal-details{
  width: 145px;
  margin-left: -20px;
}

#two-per-medal-details{
  width: 200px;
  margin-left: -80px;
}
.medal-player-name{
  width:80%;
  text-align: center;
}
.medal-event-name{
  width:100%;
  text-align: center;
}
.player-medal-number{
  width:20%;
  text-align: left;
}

</style>
